import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import MultipleSelectionsInput from '../../../../../../../../Resource/FormTemplates/Inputs/MultipleSelectionsInput';
import WithField from '../../../../../../../../Resource/FormTemplates/Inputs/WithField';
import { FormTemplate } from '../../../../../../../../Resource/FormTemplates/Types';
import ClientGroupsSelector from './ClientGroupsSelector';

interface Props {
  template: Maybe<FormTemplate>;
}

function Collaborators({ template }: Props) {
  return template
    .map((template) => (
      <>
        <div className="pb-6" data-intercom-target="builder-collaborators-permission-type">
          <WithField kind="single-selection" name="permission_type" fields={template.fields}>
            {(field) => (
              <MultipleSelectionsInput
                field={field}
                dataIntercomTarget="builder-collaborators-permission-type"
              />
            )}
          </WithField>
        </div>
        <ClientGroupsSelector
          template={template}
          dataIntercomTarget="builder-collaborators-client-groups"
        />
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(Collaborators);
